<template>
    <div class="d-flex flex-wrap justify-content-between">
        <SummaryBox
            :title="$t('profile.targetsTable.sum')"
            :subtitle="$tc('profile.targetsTable.weight', 2)"
            :info="`${formatPercentage(consolidated.totalWeight)}%`"
        />
        <SummaryBox
            :subtitle="$t('targets.realized')"
            :title="$t('profile.targetsTable.sum')"
            :info="`${formatPercentage(consolidated.achieved)}%`"
        />
        <SummaryBox
            v-if="showSelfEvaluation"
            :title="$t('profile.targetsTable.sum')"
            :subtitle="$t('profile.targetsTable.selfEvaluate')"
            :info="`${formatPercentage(consolidated.ownerEvaluations)}%`"
        />
        <SummaryBox
            v-if="showManagerEvaluation"
            :title="$t('profile.targetsTable.sum')"
            :subtitle="$t('profile.targetsTable.managerEvaluate')"
            :info="`${formatPercentage(consolidated.managerEvaluations)}%`"
        />
        <SummaryBox
            v-if="showCommitteeEvaluation"
            :title="$t('profile.targetsTable.sum')"
            :subtitle="$t('profile.targetsTable.committeeEvaluation')"
            :info="`${formatPercentage(consolidated.committeeEvaluations)}%`"
        />
    </div>
</template>

<script>
import SummaryBox from '../summary-box/index'
import { formatPercentage } from '@/lib/utils'
import { getTargetsConsolidate as getTargetsConsolidateFromApi } from '../targets/api'
import { userPermissionsMixin } from '@/mixins'
export default {
    name: 'TargetsSummary',
    mixins: [userPermissionsMixin],
    components: {
        SummaryBox,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            periods: [],
            consolidated: {
                achieved: 0,
                totalWeight: 0,
                ownerEvaluations: 0,
                managerEvaluations: 0,
                committeeEvaluations: 0,
            },
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser.user
        },
        showSelfEvaluation() {
            return this.hasEventPermission(
                this.currentUser.permissions,
                'goals',
                'consolidated',
                'allow_view_self_evaluation'
            )
        },
        showManagerEvaluation() {
            return this.hasEventPermission(
                this.currentUser.permissions,
                'goals',
                'consolidated',
                'allow_view_manager_evaluation'
            )
        },
        showCommitteeEvaluation() {
            return this.hasEventPermission(
                this.currentUser.permissions,
                'goals',
                'consolidated',
                'allow_view_committee_evaluation'
            )
        },
    },
    mounted() {
        this.periods = this.$store.state.filters.periods
        this.$store.watch(
            (state) => state.filters.periods,
            (periods) => {
                this.periods = periods
                this.getTargetsConsolidate()
            }
        )
    },
    methods: {
        getTargetsConsolidate() {
            getTargetsConsolidateFromApi(this.user.id, this.periods, [
                'unit',
                'department',
                'personal',
            ]).then((resp) => {
                this.consolidated = resp
            })
        },
        formatPercentage(value) {
            return formatPercentage(value)
        },
    },
    watch: {
        user(newUser, oldUser) {
            if (newUser != oldUser) {
                this.getTargetsConsolidate()
            }
        },
    },
}
</script>
